// extracted by mini-css-extract-plugin
module.exports = {"actions":"FilesTable_actions__bV0tI","svgThumbnail":"FilesTable_svgThumbnail__2w_q4"};